require('./style.less');

var Modal = require('../../common/modal/modal'),
    _ = require('underscore');

require('extendMoment');


module.exports = Modal.extend({

    contentTemplate: require('./template.hbs'),

    initialize: function( options ) {

        Modal.prototype.initialize.call( this, _.extend( {}, options, {
            content: this.contentTemplate(
                this.serializeContentTemplateData( options.docModel, options.docLockStatus )
            ),
            hideFooter: true
        }) );

        return this;
    },

    serializeContentTemplateData: function( docModel ) {

        var userLock = docModel.get('userLock'),
            mtime =  moment.convertDBTimeToLocalTime( docModel.get('modifyTime') ),
            context = {
                docID: docModel.getId(),
                ctime: moment.convertDBTimeToLocalTime( docModel.get('creationTime') ),
                mtime: mtime,
                docIsLocked: userLock !== null
            };


        if (userLock) {

            var userLockDescription = docModel.get('userDesc');

            _.extend( context, {
                lockUser: userLockDescription // ( user description can be null )
                    ? userLockDescription
                    : userLock,
                lockTime: mtime
            });
        }

        return context;



    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/dialogs/docInfo/view.js
 ** module id = 261
 ** module chunks = 0
 **/